import api from 'api';
import { DesignTemplates } from 'records/DesignTemplate';

export const FILTER_SEARCH_BG_RESULTS_ASYNC_ACTION_START = 'FILTER_SEARCH_BG_RESULTS_ASYNC_ACTION_START';
export const FILTER_SEARCH_BG_RESULTS_ASYNC_ACTION_ERROR = 'FILTER_SEARCH_BG_RESULTS_ASYNC_ACTION_ERROR';
export const FILTER_SEARCH_BG_RESULTS_ASYNC_ACTION_SUCCESS = 'FILTER_SEARCH_BG_RESULTS_ASYNC_ACTION_SUCCESS';
export const FILTER_SEARCH_BG_RESULTS_RESET_STATE = 'FILTER_SEARCH_BG_RESULTS_RESET_STATE';

function filterSearchBgResultsAsyncActionStart() {
  return {
    type: FILTER_SEARCH_BG_RESULTS_ASYNC_ACTION_START,
  };
}

function filterSearchBgResultsAsyncActionError(error) {
  return {
    type: FILTER_SEARCH_BG_RESULTS_ASYNC_ACTION_ERROR,
    error,
  };
}

function filterSearchBgResultsAsyncActionSuccess(data) {
  return {
    type: FILTER_SEARCH_BG_RESULTS_ASYNC_ACTION_SUCCESS,
    data,
  };
}

export function resetfilterSearchBgResultsState() {
  return {
    type: FILTER_SEARCH_BG_RESULTS_RESET_STATE,
  };
}

export function getfilterSearchBgResults( designTypeId, designSizeId, filterKey ) {
  return (dispatch, getState) => {
    dispatch(filterSearchBgResultsAsyncActionStart());
    return api.request(
      `design/filterbg?filterkey=${ filterKey }&designtid=${ designTypeId }&sizeid=${ designSizeId }`,
      'get',
      null
    )
    .then((data) => {
      dispatch(filterSearchBgResultsAsyncActionSuccess(data));
      return DesignTemplates(data);
    })
    .catch((err) => {
      dispatch(filterSearchBgResultsAsyncActionError('There are no design templates'));
      throw (err);
    });
  };
}

export function getfilterSearchThemeBgResults( filterKey ) {
  return (dispatch, getState) => {
    dispatch(filterSearchBgResultsAsyncActionStart());
    return api.request(
      `design/filterbg?filterkey=${ filterKey }`,
      'get',
      null
    )
    .then((data) => {
      dispatch(filterSearchBgResultsAsyncActionSuccess(data));
      return DesignTemplates(data);
    })
    .catch((err) => {
      dispatch(filterSearchBgResultsAsyncActionError('There are no design templates'));
      throw (err);
    });
  };
}
